<script>
// import Layout from '@layout/main'
import { contactBrandOptions } from '@utils/zerone-options'
import ContactLayout from './components/MenuList'
import { messageError } from '@utils/message'
// import { getDefaultBrand } from "@utils/zerone-get-default";

export default {
  page() {
    return {
      title: `其他詢問 | 關於我們`,
    }
  },
  components: {
    ContactLayout,
  },
  data() {
    return {
      submitData: {
        name: '',
        type: '',
        email: '',
        backupEmail: '',
        phoneCode: '', // 公司
        phone: '', // 公司
        extNumber: '',
        mobilePhoneCode: '+886',
        mobilePhone: '',
        faxCode: '',
        fax: '',
        city: '',
        district: '',
        address: '',
        zipcode: '',
        message: '',
        companyName: '',
        jobTitle: '',
        // brandAlias:'',
      },
      loadingSubmit: false,
      stepActive: 0,
    }
  },
  computed: {
    tableFiledList() {
      return [
        {
          col: 6,
          type: 'text',
          label: '姓名',
          placeholder: '',
          name: 'name',
          rules: 'require',
        },
        {
          col: 6,
          type: 'null',
        },
        {
          col: 6,
          type: 'text',
          label: '公司名稱',
          placeholder: '',
          name: 'companyName',
          rules: 'require',
        },
        {
          col: 6,
          type: 'text',
          label: '職稱',
          placeholder: '',
          name: 'jobTitle',
          rules: '',
        },
        {
          col: 3,
          type: 'areaCode',
          label: '聯絡電話',
          placeholder: '請選擇',
          name: 'phoneCode',
          rules: 'require',
        },
        {
          col: 6,
          type: 'text',
          label: '聯絡電話',
          placeholder: '聯絡電話',
          name: 'phone',
          rules: 'require|number',
          isTransparentLabel: true,
        },
        {
          col: 3,
          type: 'text',
          label: '分機',
          placeholder: '分機',
          name: 'extNumber',
          rules: '',
          isTransparentLabel: true,
        },
        // {
        //   col: 3,
        //   type: 'city',
        //   label: '聯絡地址',
        //   placeholder: '請選擇縣市',
        //   name: 'city',
        //   rules: '',
        // },
        // {
        //   col: 3,
        //   type: 'district',
        //   label: '區域',
        //   placeholder: '請選擇區域',
        //   name: 'district',
        //   rules: '',
        //   isTransparentLabel: true,
        // },
        // {
        //   col: 6,
        //   type: 'text',
        //   label: '地址',
        //   placeholder: '地址',
        //   name: 'address',
        //   rules: '',
        //   isTransparentLabel: true,
        // },
        // {
        //   col: 3,
        //   type: 'areaCode',
        //   label: '聯絡電話區碼',
        //   placeholder: '請選擇區碼',
        //   name: 'phoneCode',
        //   rules: 'require',
        // },
        // {
        //   col: 6,
        //   type: 'text',
        //   label: '聯絡電話',
        //   placeholder: '聯絡電話',
        //   name: 'phone',
        //   rules: 'require|number',
        // },
        // {
        //   col: 3,
        //   type: 'text',
        //   label: '分機',
        //   placeholder: '分機',
        //   name: 'extNumber',
        //   rules: '',
        //   isTransparentLabel: true,
        // },
        {
          col: 3,
          type: 'mobilePhoneCode',
          label: '手機號碼',
          placeholder: '請選擇',
          name: 'mobilePhoneCode',
          rules: 'require',
        },
        {
          col: 9,
          type: 'text',
          label: '手機號碼',
          placeholder: '手機號碼',
          name: 'mobilePhone',
          rules: `${this.submitData.mobilePhoneCode === '+886' ? 'require|phone' : 'require'}`,
          isTransparentLabel: true,
        },
        {
          col: 6,
          type: 'email',
          label: 'E-mail',
          placeholder: '',
          name: 'email',
          rules: 'require|email',
        },
        {
          col: 6,
          type: 'email',
          label: '備用E-mail',
          placeholder: '備用E-mail',
          name: 'backupEmail',
          rules: '',
          isTransparentLabel: true,
        },
        {
          col: 9,
          type: 'radio',
          label: '類別',
          placeholder: '',
          name: 'type',
          rules: 'require',
          options: [
            {
              text: '帳號登入問題',
              value: '帳號登入問題',
            },
            {
              text: '客訴反應',
              value: '客訴反應',
            },
            {
              text: '申請變更手機號碼',
              value: '申請變更手機號碼',
            },
            {
              text: '申請成為經銷商',
              value: '申請成為經銷商',
            },
            {
              text: '其他',
              value: '其他',
            },
          ],
        },
        {
          col: 12,
          type: 'textarea',
          label: '留言',
          placeholder: '',
          name: 'message',
          rules: 'require',
          description: '',
        },
      ]
    },
  },
  created() {
    if (this.$route.params.tobeDealer) {
      this.submitData.type = '申請成為經銷商'
    } else if (this.$route.params.phone === 'phone') {
      this.submitData.type = '申請變更手機號碼'
    }
  },

  methods: {
    onSubmit() {
      this.tryToXxxxx()
    },
    async tryToXxxxx() {
      this.loadingSubmit = true
      // const { district} =  this.submitData
      const submitData = {
        ...this.submitData,
        // district: district.split(' ')[1],
        // zipcode: district.split(' ')[0],
      }
      await this.$store
        .dispatch('global/contact', submitData)
        .then((res) => {
          if (res.code === 400) {
            messageError('資料有誤，請重新填寫')
          } else {
            this.goToStep(1, 'application')
          }
        })
        .catch(() => {
          messageError('資料有誤，請重新填寫')
        })
        .finally(() => {
          this.loadingSubmit = false
        })

      /* setTimeout(() => {
         this.loadingSubmit = false;
         this.goToStep(1, 'application');
         }, 1000) */
    },
    clearFrom() {
      this.$refs.contactForm.resetFields()
    },
    goToStep(step) {
      this.stepActive = step
      this.scrollToFromTop()
    },
    scrollToFromTop() {
      const scrollTo = this.getOffsetTop(this.$refs.fromTop)

      TweenMax.to(window, 1, { scrollTo: { y: scrollTo }, ease: Power3.easeOut })
    },
    getOffsetTop(element) {
      let offsetTop = 0

      while (element) {
        offsetTop += element.offsetTop - element.scrollLeft + element.clientTop
        element = element.offsetParent
      }

      return offsetTop
    },
    againSend() {
      this.goToStep(0)
      this.$nextTick(() => {
        this.clearFrom()
      })
    },
  },
}
</script>
<template>
  <ContactLayout>
    <section ref="fromTop" :class="$style.sectionContact" class="section">
      <div class="container">
        <div :class="$style.contactBox" class="bg-gray-2">
          <div v-show="stepActive === 0">
            <div> 如果您有任何問題或建議，歡迎留言，我們將會立即與您聯絡，謝謝!</div>
            <hr />
            <BaseForm ref="contactForm" v-model="submitData" :list="tableFiledList" :loading="loadingSubmit" @cancel="clearFrom" @submit="onSubmit" />
          </div>
          <template v-if="stepActive === 1">
            <div :class="$style.formDetail"> 您的留言已成功送出,我們將會用最快的速度與您聯絡,謝謝! </div>
            <hr />
            <div class="row mt-5">
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100" @click="againSend('application')"> 再次填寫 </BaseButton>
              </div>
              <div class="col">
                <BaseButton class="isStylePrimary isSmall isRadius isOutline2 w-100" :to="{ name: 'home' }"> 回首頁 </BaseButton>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>
  </ContactLayout>
</template>
<style lang="scss" module>
.sectionContact {
  :global {
    .sectionContact {
    }
    .isStyleField {
      width: 100% !important;
    }
  }
}

.contactBox {
  padding: 3.75rem 3.125rem;

  @include max-md {
    padding: 2rem 1rem;
  }

  :global {
    .contactBox {
    }
  }
}

.formDetail {
  padding: 3.75rem 4rem;
  font-size: 1rem;
  line-height: 2;
  background: #fff;

  :global {
    .formDetail {
    }
  }
}
</style>
